import request from "../utlis/request"

//ticket获取token
export function ticketApi(param){
  return request({
    url: '/ticket',
    method: 'post',
    data: param,
    urltype: 'auth',
  })
}

//获取验证码
export function getSMS(param){
  return request({
    url: '/sms',
    method: 'get',
    params: param,
    urltype: 'auth',
  })
}

//绑定手机号
export function bindPhone(param){
  return request({
    url: '/bind',
    method: 'post',
    data: param,
    urltype: 'auth',
  })
}



// WEBPACK FOOTER //
// ./src/api/auth_api.js